import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { API } from "../api/api";
import { APIRequestErrorInterface } from "../api/fetchApi";
import LoginInput from "../components/inputs/LoginInput";
import { useApiCall } from "../hooks/useApiCall";
import i18nStore from "../i18n/store";
import authUserStore from "../modules/auth/store";
import MyAlertDialog from "../ui/AlertDialog";
import { validateEmailFormat } from "../utils/validateEmail";


const ProfilePage = observer(() => {
    const translations = i18nStore.getTranslations;
    const { enqueueSnackbar } = useSnackbar();

    const [email, setEmail] = useState<string>(authUserStore.getMe?.email || "");
    const [login, setLogin] = useState<string>(authUserStore.getMe?.name || "");
    const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);

    const deleteProfileApi = useApiCall(
        () => API.auth.deleteProfile()
            .then(() => {
                enqueueSnackbar(translations._profile.successAccountDeletedMsg, {variant: "info"});
                authUserStore.delete();
            })
            .catch((err: APIRequestErrorInterface) => {
                enqueueSnackbar(err.details.detail, {variant: "error"});
            })
            .finally(() => {
                setOpenDeleteDialog(false);
            }),
        null,
    );

    return (
        <Container maxWidth="md" sx={{}}>
            <Typography component="h1" variant="h6">
                {translations._profile.profilePageHeader}
            </Typography>

            <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={Boolean(!validateEmailFormat(email))}
                margin="normal"
                type="email"
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                size="small"
                disabled
            />

            <LoginInput login={login} setLogin={setLogin} myLogin={true} />

            <Button
                color="success"
                variant="contained"
                sx={{ my: 2 }}
            >
                {translations.save}
            </Button>

            <Box sx={{ mt: 15, }}>
                <Button
                    color="error"
                    variant="contained"
                    onClick={() => setOpenDeleteDialog(true)}
                >
                    {translations._profile.deleteProfile}
                </Button>
                <MyAlertDialog
                    open={openDeleteDialog}
                    handleClose={() => setOpenDeleteDialog(false)}
                    handleAgree={() => deleteProfileApi.apiCaller()}
                    agreeLoading={deleteProfileApi.loading}
                    agreeText={translations.delete}
                    disagreeText={translations.cancel}
                    questionText={translations._profile.deleteProfile + "?"}
                    contentText={translations._profile.deleteDialogText}
                />
            </Box>

        </Container>
    );
});


export default ProfilePage;
